<template>
  <div>
  <section>
    <div class="left">
      <h2 v-translate>Výběr profilu</h2>
    </div>
  <div class="right">
    <div class="field_left">
      <select-box id="restricstedChannelsProfile"
                  v-model="selectedIdProfile"
                  :options="profileOptions"
                  ref="restrictedChannelsProfileref"
                  :disabled="!$_updateActionAllowed"
                  @input="loadProfileData"
      ><translate class="translate">Profil odběratele</translate>
      </select-box>
  </div>
  </div>
  </section>
    <channel-checkbox-list-section
        :search-keys="['name']"
        :prepend-channel-id="false"
        :title="'Zakázané kanály' | translate"
        group-id="channels"
        :items="subscriberChannels"
        name="channels"
        :selected-items="restrictedChannels"
        @toggle-select="restrictedChannels = arguments[0]"
        :editable="$_updateActionAllowed"
        :show-select-all="false"
    ></channel-checkbox-list-section>
  <section class="buttons">
    <p>
      <router-link
          :to="{ name: 'subscriberDetailRestrictedChannels' }"
          class="btn btn_back btn_seznam"
          v-translate>Seznam
      </router-link>
      <input
          type="submit"
          :value="'Uložit zakázané kanály' | translate"
          class="btn"
          @click.prevent.stop="saveRestrictedChannels"
          v-if="$_updateActionAllowed"
      />
    </p>
  </section>
  </div>
</template>

<script>
import message from "@/components/mixins/message";
import ChannelCheckboxListSection from "../../../common/ChannelCheckboxListSection.vue";

export default {
  name: "RestrictedChannelList",
  mixins: [message],
  components: {ChannelCheckboxListSection},
  props: {
    idSubscriber: Number,
  },
  data() {
    return {
      allChannels: [],
      subscriberChannels: [],
      restrictedChannels: [],
      profileOptions: [],
      selectedIdProfile: null,
    };
  },
  created(SubscriberService, SubscriberProfileService) {
    this.subscriberService = SubscriberService;
    this.subscriberProfileService = SubscriberProfileService;

    this.subscriberService.getOperatorChannels(this.idSubscriber).then((data) => {
      this.allChannels = data['all_channels']
      this.loadPermanentSettings();
    })
  },
  methods: {
    loadPermanentSettings(){
      this.subscriberProfileService.getSelectboxList(this.idSubscriber, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
          .then(data => {
            this.profileOptions = data['subscriber_profiles'];
            let index = this.profileOptions.findIndex((profile)=> {
              return profile.id === null
            });
            this.profileOptions[index].text = this.$gettext("Výchozí profil odběratele");
          });
      this.subscriberService.getSubscriberServiceIntervals(this.idSubscriber)
          .then(data => {
            let indexedChannels = {};
            this.subscriberChannels = [];
            this.allChannels.forEach((item) => {
              indexedChannels[item.id] = item;
            });
            data.summed.all_channels_ids.forEach((id) => {
              this.subscriberChannels.push({...indexedChannels[id]});
            })
            this.loadProfileData();
          })

    },
    loadProfileData(){
      this.restrictedChannels = [];
      this.setLoadingMessage();
      this.subscriberService.getSubscriberProfileRestrictedChannels(this.idSubscriber, {id_subscriber_profile: this.selectedIdProfile})
          .then((data) => {
            this.restrictedChannels = data.restricted_channels == null ? [] : data.restricted_channels;
            this.emptyMessage();
          });
    },
    saveRestrictedChannels(){
      this.subscriberService.updateSubscriberProfileRestrictedChannels(this.idSubscriber, {id_subscriber_profile: this.selectedIdProfile, restricted_channels: this.restrictedChannels});
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/restrictedChannels/RestrictedChannelsList.vue